import React from "react";
import Tooltip from "./../tooltip/Tooltip";

// -----------------------------------------------------------------
// I n t e r f a c e s
// -----------------------------------------------------------------
interface Props {
  id?: string;
  className?: string;
  disabled?: boolean;
  loading?: boolean;
  submit?: boolean;
  onClick?: any;
  title?: string;
  children: any;
  tooltip?: string;
}

const Button = ({
  id,
  className,
  disabled,
  loading,
  submit,
  onClick,
  children,
  title,
  tooltip,
  ...props
}: Props) => {
  // -----------------------------------------------------------------
  // L o c a l   v a r s
  // -----------------------------------------------------------------

  // -----------------------------------------------------------------
  // N a v i g a t i o n   v a r s
  // -----------------------------------------------------------------

  // -----------------------------------------------------------------
  // S t a t e
  // -----------------------------------------------------------------

  // -----------------------------------------------------------------
  // R e f s  (DOM)
  // -----------------------------------------------------------------

  // -----------------------------------------------------------------
  // u s e S e l e c t o r   m e t h o d s  (redux)
  // -----------------------------------------------------------------

  // -----------------------------------------------------------------
  // W o r k i n g   m e t h o d s
  // -----------------------------------------------------------------

  // -----------------------------------------------------------------
  // R e n d e r   m e t h o d s
  // -----------------------------------------------------------------

  // -----------------------------------------------------------------
  // L i f e c y c l e
  // -----------------------------------------------------------------

  // -----------------------------------------------------------------
  // u s e E f f e c t   m e t h o d s
  // -----------------------------------------------------------------

  // -----------------------------------------------------------------
  // T e m p l a t e
  // -----------------------------------------------------------------
  return (
    <>
      <button
        id={id}
        title={title || ""}
        onClick={onClick}
        className={className}
        disabled={disabled}
        type={submit ? "submit" : "button"}
        data-tip={tooltip}
      >
        {children}

        {!!loading && <i className="fas fa-spinner fa-spin"></i>}
      </button>

      {!!tooltip && <Tooltip />}
    </>
  );
};
export default Button;
